import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Wrapper = styled('header')`
  margin-bottom: -1px;
  padding-top: ${({ theme }) => theme.x1spacePx}px;
  ${media.lgUp`
    padding: 0;
	`};
`;

export const Filter = styled('div')`
  margin: 0;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdDown`
    margin: ${({ theme }) => `0 ${theme.x2spacePx}px ${theme.x1spacePx}px`};
	`};
`;

export const TotalRecords = styled('p')`
  margin: ${({ theme }) => `0 ${theme.x2spacePx}px`};
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  ${media.lgUp`
    margin-left: 0;
    margin-right: 0;
	`};
`;

export const Message = styled('p')`
  ${({ theme }) => theme.typography.base};
  color: ${({ theme }) => theme.color.white};
  text-align: center;
  margin: ${({ theme }) => `${theme.x6spacePx}px 0`};
  ${media.mdDown`
    margin: ${({ theme }) => `${theme.x6spacePx}px ${theme.x2spacePx}px`};
  `}
`;
